<template>
	<div>
        <div v-if="avatarBackup.value" id="avatar" class="avatar relative show-hover-container" :class="addClasses(avatarBackup.type)" >

            <!-- PICTURE -->
            <img 
                v-if="avatarBackup.type == 'picture' || avatarBackup.type == 'twitteruserpic'"
                :src="avatarBackup.value" 
                alt=""
                @click="goTo">
            
            <!-- INITIAL -->
            <span 
                v-else 
                @click="goTo">
                {{avatarBackup.value}}
            </span>

            <!-- OVERLAY -->
            <div v-if="editable"
                class="absolute top-left bottom-right icon-16 show-hover-item cpointer primary-50-bkg white br" 
                @click="openAvatarModal">
                <i class="icon-setting absolute-center"></i>
            </div>
        </div>
	</div>
	
</template>
<script>
    import { createNamespacedHelpers } from 'vuex'
    const popupPanelMapActions  = createNamespacedHelpers('popupPanel').mapActions;

	export default {
		props : {
			avatar : {
				required: true,
            },
            size: {
                type: String,
                required: false,
                default: 'medium'
            },
            editable: {
                type: Boolean,
                required: false,
                default: false
            },
            route: {
                type: String,
                required: false,
                default: ''
            }
        },
        
		data () {
			return {
                displayAvatarDialog : false,
                avatarType : "",
                avatarVal : "",
                avatarBackup: {}
			}
        },
        created(){
            EventBus.$on('modal:avatar-uploader:on-remove', (payload) => {
                this.removeImg(payload.res)
            })
            EventBus.$on('modal:avatar-uploader:on-change', (payload) => {
                this.beforeAvatarUpload(payload.file)
            })
            EventBus.$on('modal:avatar-uploader:on-success', (payload) => {
                this.handleAvatarSuccess(payload)
            })
            if(this.avatar){
                this.avatarType = this.avatar.type;
                this.avatarVal   = this.avatar.value;
                this.avatarBackup = this.avatar;
            }
        },
        methods: {
            ...popupPanelMapActions([
                'open',
            ]),
            openAvatarModal(){ 
                this.open({
                    key: 'avatarUploader',
                    props: {
                        avatar : this.avatar,
                        route: this.route,
                    }
                })
            },

            handleAvatarSuccess(payload) {
                this.avatarBackup = payload.res;
                this.$store.dispatch('setAvatar', payload.res);
                this.displayAvatarDialog = false;
            },
            
            beforeAvatarUpload(file) {
                this.avatarVal = file.url;
                this.avatarType = "picture";
            },

            removeImg(res) {                
                this.avatarVal = res.value;
                this.avatarType = res.type;
                this.avatarBackup = res;
                this.$store.dispatch('setAvatar', res);
                this.displayAvatarDialog = false;
            },
            addClasses(type){
				let classes = '';
				if(type == 'picture' || type == 'twitteruserpic'){
					classes += ' avatar-picture white-bkg';
				}
				if(this.size != 'medium'){
					classes += ' avatar-'+this.size+' ';
                }
                if(this.editable){
                    classes += ' avatar-editable ';
                }
				return classes;
            },
            goTo(){
                if(!this.editable && this.$attrs.type && this.$attrs.type != ''){
                    switch(this.$attrs.type){
                        case 'staff':
                            window.location.href = `/staff/${this.$attrs.id}`;
                            break;
                    }
                }
            }
        },

        computed : {
            id(){ return this.$store.getters.linkedid; }
        },

        watch: {
            avatar: function (val) {
                if(val){
                    this.avatarType = val.type;
                    this.avatarVal   = val.value;
                    this.avatarBackup = val;
                }
            },
        },
        destroyed() {
            EventBus.$off('modal:avatar-uploader:on-remove')
            EventBus.$off('modal:avatar-uploader:on-change')
            EventBus.$off('modal:avatar-uploader:on-success')
        }
	}
</script>

<style lang='scss' scoped>
    .avatar {
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            max-width: 100%;
            max-height: 100%;
        }
    }
</style>